export const useSnack = () => {
  const snack = useToast().add
  return {
    success: (description: string) =>
      snack({
        title: 'Success',
        description,
        color: 'green',
        timeout: 10000
      }),
    error: (description: string) =>
      snack({
        title: 'Error',
        description,
        color: 'red',
        timeout: 10000
      })
  }
}
